<template>
  <section class="careers-in-bravado relative">
    <div class="page-container">
      <div class="careers-in-bravado__wrapper relative locked" data-aos="fade-up">
        <h2 class="careers-in-bravado__title mb4">
          We&rsquo;re building
          <em class="relative px1">a&nbsp;winning team.</em>
          Are you&nbsp;in?
        </h2>

        <p class="careers-in-bravado__subtitle">
          If&nbsp;you think you might be&nbsp;a&nbsp;good fit for our team, we&rsquo;d love to&nbsp;hear from you!
          If&nbsp;none of&nbsp;our open roles stand out to&nbsp;you, send&nbsp;us an&nbsp;email to
          <a href="mailto:hello@bravado.co" target="_blank">hello@bravado.co</a>
        </p>

        <BravadoButtonV3
          data-test="careers-page-apply-open-roles-button"
          rel="nofollow"
          href="https://boards.greenhouse.io/bravado"
          target="_blank"
          variant="primary"
          size="lg"
        >
          <span class="px3">Apply for open roles</span>
        </BravadoButtonV3>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import Vue from 'vue';
import BravadoButtonV3 from '~/components/common/BravadoButtonV3/BravadoButtonV3.vue';

export default Vue.extend({
  name: 'CareersInBravado',
  components: { BravadoButtonV3 },
});
</script>

<style lang="scss" scoped>
.careers-in-bravado {
  z-index: 1;
  margin: 0 0 70px;

  @include mq('md') {
    padding: 20px 0 0;
    margin: 0 0 125px;
  }

  &__wrapper {
    background: url('~@/components/partials/landings/careers/images/bg/in-bravado-bg.webp') no-repeat center top;
    background-size: cover;
    mix-blend-mode: soft-light;
    border-radius: 16px;
    z-index: 1;
    padding: 20px 24px 32px;
    text-align: center;

    @include mq('md') {
      padding: 46px 24px 55px;
      border-radius: 32px;
    }
  }

  &__title {
    color: var(--color-text);
    text-align: left;

    em {
      font-style: normal;
    }

    @include bravado-h4;

    @include mq('sm') {
      text-align: center;
      margin-bottom: 25px;

      @include bravado-h2;

      em {
        font-style: italic;
        margin-right: 2px;
        color: var(--white);
        white-space: nowrap;

        &::after {
          content: '';
          height: 14px;
          width: 225px;
          background: url('~@/components/partials/landings/careers/images/bg/in-bravado-underline.svg') no-repeat left
            top;
          background-size: 180px 9px;
          position: absolute;
          bottom: -12px;
          left: -7px;
          animation: underline-animation 1.5s;

          @include mq('md') {
            background-size: 221px;
            bottom: -13px;
            left: -5px;
          }
        }
      }
    }
  }

  &__subtitle {
    color: var(--color-text);
    max-width: 800px;
    margin: 0 auto 32px;
    text-align: left;

    @include body;

    @include mq('sm') {
      margin-bottom: 45px;

      @include bravado-super-headline;
    }

    a {
      color: #fff;
      text-decoration: underline;

      &:hover {
        text-decoration: none;
      }
    }
  }
}

@keyframes underline-animation {
  from {
    width: 0;
  }

  to {
    width: 250px;
  }
}
</style>
